

































































































































//
import Vue from 'vue'
import { mapState } from 'vuex'

import UpgradeToProButton from './UpgradeToProButton.vue'
import Avatar from './avatar/Avatar.vue'

import apiClient, { handleHttpErrors } from '../../utils/apiClient'
import { AccountDto, PlanCategory } from '../../utils/api'
import { getAmazonDefaultsURL } from '../../utils/images'

export default Vue.extend({
  components: {
    Avatar,
    UpgradeToProButton,
  },
  props: {
    activeDropdownItem: {
      type: String,
      default: '',
    },
    isVisible: Boolean,
  },
  data() {
    return {
      PlanCategory,
    }
  },
  computed: {
    ...mapState({
      user: (state: any) => <AccountDto>state.auth.user,
      countUnread: (state: any) => state.auth.user.plan.unreadNotifications,
    }),
    avatarName(): string {
      return !!this.user.fullName ? this.user.fullName : 'itmeo'
    },
    menuTop(): Array<any> {
      return [
        {
          name: 'My Store',
          icon: 'store',
          link: '/dashboard/my-store',
          isNewPage: false,
          width: 15,
          height: 15,
        },
        {
          name: 'Link in Bio',
          icon: 'link-in-bio',
          link: `/${this.user.userName}`,
          isNewPage: false,
          width: 16,
          height: 16,
        },
        {
          name: 'Edit Profile',
          icon: 'edit-profile',
          link: '/dashboard/profile',
          isNewPage: false,
          width: 16,
          height: 16,
        },
        {
          name: 'My orders',
          icon: 'shop-product',
          link: `/dashboard/my-orders`,
          isNewPage: false,
          width: 14,
          height: 14,
        },
        {
          name: 'My Favorites',
          icon: 'like',
          link: `/favorites`,
          isNewPage: false,
          width: 16,
          height: 16,
        },
        {
          name: 'Notifications',
          icon: 'notifications',
          link: '/dashboard/notifications',
          isNewPage: false,
          width: 16,
          height: 18,
        },
        /*         {
          name: 'Discover',
          icon: 'discover',
          link: '/feed',
          isNewPage: false,
        }, */
      ]
    },
    menuBottom(): Array<any> {
      return [
        {
          name: 'Pricing',
          icon: 'pricing',
          link: '/pricing',
          width: 15,
          height: 15,
          isMobile: true,
        },
        {
          name: 'Settings',
          icon: 'settings_h',
          link: '/dashboard/settings',
          width: 14,
          height: 14,
          isMobile: false,
        },
        {
          name: 'Help',
          icon: 'help',
          link: '/dashboard/help',
          width: 14,
          height: 14,
          isMobile: false,
        },
        {
          name: 'Log out',
          icon: 'logout',
          click: this.logout,
          isClick: true,
          width: 12,
          height: 14,
          isMobile: false,
        },
      ]
    },
    srcFacebook() {
      return getAmazonDefaultsURL('facebook.svg')
    },
    srcTwitter() {
      return getAmazonDefaultsURL('x-logo.svg')
    },
    srcInstagram() {
      return getAmazonDefaultsURL('instagram.svg')
    },
  },
  methods: {
    logout(event: Event) {
      if (event) event.preventDefault()

      apiClient.auth
        .authLogout()
        .then(() => {
          //this.$store.commit('auth/changeIsUserLoggedIn', false)
          // this.$store.commit('auth/changeUser', null)
          location.href = '/login'
        })
        .catch((error) => handleHttpErrors(this.$store))
    },
  },
})
